import { render } from "./goaltracking-modal.vue?vue&type=template&id=a6c86c7c"
import script from "./goaltracking-modal.vue?vue&type=script&lang=js"
export * from "./goaltracking-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__